"use client";

import { createContext, useContext } from "react";

/**
 * Les sources d'un outil et les dates de leur veille, pour ses panneaux
 * d'explication.
 *
 * LA PAGE LES ENVOIE, LE NAVIGATEUR NE LES CHERCHE PAS. Le catalogue entier
 * (lib/tools/sources.js) compte plus d'une centaine de sources, attendus de la
 * veille compris : l'envoyer à chaque visiteur pour afficher trois liens
 * n'aurait pas de sens. La page de l'outil, côté serveur, ne passe ici que ses
 * sources, libellées dans la langue lue, et la date à laquelle la veille a
 * retrouvé chacune sur sa page officielle : la même que « Informations
 * vérifiées le », sous l'outil.
 */
const Contexte = createContext({ sources: {}, dates: {} });

export function SourcesVerifiees({ sources = {}, dates = {}, children }) {
    return <Contexte.Provider value={{ sources, dates }}>{children}</Contexte.Provider>;
}

export const useSourcesVerifiees = () => useContext(Contexte);
